export * from './media'
export * from './layout'
export * from './support'
export * from './news'
export * from './home'
export * from './games'
export * from './about'
export * from './form'
export * from './privacy'
export * from './swiper'
export * from './toast'
export * from './metadata'
export * from './cookie'
